'use client';
export {
  ArrowRight,
  ArrowSquareOut,
  BellSimple,
  CaretDoubleDown,
  CaretDoubleUp,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  Chats,
  CheckCircle,
  Circuitry,
  CopySimple,
  Cube,
  Folder,
  GearSix,
  GraduationCap,
  Headphones,
  Heart,
  HeartStraight,
  ImageSquare,
  InstagramLogo,
  Layout,
  List,
  MagicWand,
  MagnifyingGlass,
  Medal,
  MegaphoneSimple,
  Minus,
  Notepad,
  Pause,
  PencilSimple,
  Percent,
  Play,
  Plug,
  Plus,
  PlusCircle,
  PuzzlePiece,
  Question,
  RocketLaunch,
  ShieldCheck,
  ShoppingCart,
  SignIn,
  SignOut,
  SquaresFour,
  Star,
  StarHalf,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash,
  TwitterLogo,
  Upload,
  UserCircle,
  UserPlus,
  WarningOctagon,
  Wrench,
  X,
  XCircle,
  YoutubeLogo,
} from '@phosphor-icons/react';
